import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { moment } from "utils"
import { Checkbox } from "components"
import classes from "./FailedPrintTableRow.module.scss"

const FailedPrintTableRow = props => {
  const {
    isSelected,
    failedPrint,
    setSelectedFailedPrints
  } = props

  const [t] = useTranslation()

  const handleSelect = () => {
    setSelectedFailedPrints(prev => {
      const object = { ...prev }

      if (!!object[failedPrint.printRequestId]) {
        delete object[failedPrint.printRequestId]
      } else {
        object[failedPrint.printRequestId] = failedPrint
      }

      return object
    })
  }

  return (
    <tr className={classes["item"]}>
      <td className={classes["cell"]}>
        <Checkbox
          checked={isSelected}
          onChange={handleSelect}
          className={classes["checkbox"]}
        />
      </td>
      {
        failedPrint.printType === "order" &&
        <Fragment>
          <td className={classes["cell"]}>
            <div>
              {t("رسید_مشتری")}
            </div>
            <div>
              {t("کد_سفارش")}: {failedPrint.printData.code}
            </div>
          </td>
          <td className={classes["cell"]}>
            <div>{moment(failedPrint.printData.date).format("jYYYY/jMM/jDD")}</div>
            <div>{moment(failedPrint.printData.date).format("HH:mm")}</div>
          </td>
        </Fragment>
      }
      {
        failedPrint.printType === "cart" &&
        <Fragment>
          <td className={classes["cell"]}>
            <div>
              {t("رسید_مشتری")}
            </div>
            <div>
              {t("شماره")}: {failedPrint.printData.queueNumber}
            </div>
          </td>
          <td className={classes["cell"]}>
            <div>{moment(failedPrint.printData.date).format("jYYYY/jMM/jDD")}</div>
            <div>{moment(failedPrint.printData.date).format("HH:mm")}</div>
          </td>
        </Fragment>
      }
      {
        failedPrint.printType === "orderEdited" &&
        <Fragment>
          <td className={classes["cell"]}>
            <div>
              {t("ویرایش_سفارش")}
            </div>
            <div>
              {t("کد_سفارش")}: {failedPrint.printData.code}
            </div>
          </td>
          <td className={classes["cell"]}>
            <div>{moment(failedPrint.printData.date).format("jYYYY/jMM/jDD")}</div>
            <div>{moment(failedPrint.printData.date).format("HH:mm")}</div>
          </td>
        </Fragment>
      }
      {
        failedPrint.printType === "shift" &&
        <Fragment>
          <td className={classes["cell"]}>
            {t("شیفت")} {failedPrint.printData.fullName}
          </td>
          <td className={classes["cell"]}>
            <div>{moment(failedPrint.printData.date).format("jYYYY/jMM/jDD")}</div>
            <div>{moment(failedPrint.printData.date).format("HH:mm")}</div>
          </td>
        </Fragment>
      }
      {
        failedPrint.printType === "offlineOrder" &&
        <Fragment>
          <td className={classes["cell"]}>
            {t("سفارش_آفلاین")}: {failedPrint.printData.code}
          </td>
          <td className={classes["cell"]}>
            <div>{moment(failedPrint.printData.date).format("jYYYY/jMM/jDD")}</div>
            <div>{moment(failedPrint.printData.date).format("HH:mm")}</div>
          </td>
        </Fragment>
      }
      {
        failedPrint.printType === "tableMoved" &&
        <Fragment>
          <td className={classes["cell"]}>
            {t("میز_تغییر_کرده")}
          </td>
          <td className={classes["cell"]}>
            <div>{moment(failedPrint.printData.date).format("jYYYY/jMM/jDD")}</div>
            <div>{moment(failedPrint.printData.date).format("HH:mm")}</div>
          </td>
        </Fragment>
      }
      {
        failedPrint.printType === "combinedOrder" &&
        <Fragment>
          <td className={classes["cell"]}>
            {t("سفارش_ترکیب_شده")}
          </td>
          <td className={classes["cell"]}>
            <div>{moment(failedPrint.printData.date).format("jYYYY/jMM/jDD")}</div>
            <div>{moment(failedPrint.printData.date).format("HH:mm")}</div>
          </td>
        </Fragment>
      }
      {
        failedPrint.printType === "deletedOrder" &&
        <Fragment>
          <td className={classes["cell"]}>
            {t("کد_سفارش_حذف_شده")}: {failedPrint.printData.code}
          </td>
          <td className={classes["cell"]}>
            <div>{moment(failedPrint.printData.date).format("jYYYY/jMM/jDD")}</div>
            <div>{moment(failedPrint.printData.date).format("HH:mm")}</div>
          </td>
        </Fragment>
      }
    </tr>
  )
}

export default React.memo(FailedPrintTableRow)